export const PRICING_MODELS = {
  fixed: 'FIXED_PRICE',
  auction: 'AUCTION'
};
